// extracted by mini-css-extract-plugin
export default {"actionButtons":"operatorTable_actionButtons__aMKnN","closingBalance":"operatorTable_closingBalance__fBk3E","alignRight":"operatorTable_alignRight__OrpNN"};